import { factoryImage, type Image } from "@/services/images";
import { type MarketplaceItem } from "@/services/marketplace/item";
import { type MaybeRef, unref } from "vue";

export function useMarketplaceItemImages(marketplaceItem: MaybeRef<MarketplaceItem | undefined>) {
  const images = computed((): Image[] => {
    const marketplaceItemUnrefed = unref(marketplaceItem);
    if (marketplaceItemUnrefed === undefined) {
      return [];
    } else {
      const name = marketplaceItemUnrefed.name;
      return marketplaceItemUnrefed.images.map((rawImageData) => factoryImage(rawImageData.id, rawImageData.imageUrl, name));
    }
  });

  const coverImage = computed((): Image | undefined => {
    return images.value[0];
  });

  return {
    images,
    coverImage,
  };
}
